module.exports = __webpack_public_path__ + "static/index-logo.829cd11d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/index-logo.png
// module id = 298
// module chunks = 2